import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const accordionStyles = () => css`
  label: accordion;

  position: relative;
`
const accordionItemStyles = () => css`
  label: accordion__item;

  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    margin-bottom: 1px;
  }
`
const titleStyles = ({ theme }) => css`
  color: ${theme.colors.p500};
`

const wrapperTitleStyles = ({ theme }) => css`
  label: accordion__wrapper-title;

  position: relative;
  padding: ${theme.spacings.kilo} ${theme.spacings.giga};
  padding-right: ${theme.spacings.exa};

  cursor: pointer;

  background: ${theme.colors.background};
  border-bottom: 2px solid ${theme.colors.white};
`

const contentStyles = ({ theme }) => css`
  label: accordion__content;

  background: ${theme.colors.background};

  overflow: hidden;
  transition: max-height 300ms ease;
`

const contentTextStyles = ({ theme }) => css`
  padding: ${theme.spacings.kilo} ${theme.spacings.exa};
`

const contentIconStyles = ({ theme }) => css`
  label: accordion__content-icon;

  position: absolute;

  top: 50%;
  right: ${theme.spacings.giga};

  transform: translateY(-50%);

  & svg {
    display: block;

    width: 15px;
    height: 15px;

    fill: ${theme.colors.p500};

    transform: rotate(90deg);
  }
`

export const Accordion = styled('div')(accordionStyles)
export const AccordionItem = styled('div')(accordionItemStyles)
export const WrapperTitle = styled('div')(wrapperTitleStyles)
export const Title = styled(Text)(titleStyles)
export const Content = styled('div')(contentStyles)
export const ContentText = styled(Text)(contentTextStyles)
export const ContentIcon = styled('div')(contentIconStyles)
